(function () {
	'use strict';

	const modules = [];

	angular.module('DcEntityModule', modules);
})();
